import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {LoaderService} from "../../service/loader.service";
import {PopupComponent} from "../popup/popup.component";
import {ContactUsService} from "../../service/contact-us.service";
import {PhoneMaskService} from "../../service/phoneMask.service";
import {CaptchaConfig} from "../../config/captcha.config";
import {LanguageService} from "../../modules/language/language.service";

// Declare the turnstile global variable from the script
declare let turnstile: any;

@Component({
    selector: 'app-popup-contact-us',
    templateUrl: './popup-contact-us.component.html',
    styleUrls: ['./popup-contact-us.component.scss']
})
export class PopupContactUsComponent implements OnInit {
    @Input() popupInfo: any = {show: false};
    @Output() close: EventEmitter<any> = new EventEmitter();

    form: FormGroup;
    phoneMask = this.phoneMaskService.setPhoneMask();

    captchaToken: string | null = null;
    constructor(private formBuilder: FormBuilder,
                private phoneMaskService: PhoneMaskService,
                private loaderService: LoaderService,
                private languageService: LanguageService,
                private contactUsService: ContactUsService,
                private popupComponent: PopupComponent) {}

    ngOnInit() {
        this.form = this.formBuilder.group({
            name: [null, Validators.required],
            phone: [null, Validators.required],
            email: [null, Validators.required],
            message: [null, Validators.required]
        });
    }

    sendForm() {
        if (!this.captchaToken) {
          this.popupComponent.showPopupError({text: this.languageService.getString('captchaIncorrectMessage')});
          return;
        }

        const name = this.form.controls.name.value;
        const phone = this.form.controls.phone.value;
        const email = this.form.controls.email.value;
        const message = this.form.controls.message.value;

        this.contactUsService.send(name, phone, email, message, this.captchaToken).subscribe(data => {
            this.setRequestResult(data);
        }, () => {
            this.loaderService.hideAndShowTryAgain();
            this.closePopup();
        }, () => {
            this.loaderService.hide();
        })
    }

    setRequestResult(data) {
        try {
            if (data.status) {
                this.popupComponent.showPopupSuccess({text: data.message});
                this.closePopup();
            } else {
                this.popupComponent.showPopupError({text: data.message});
                turnstile.reset();
            }
        } catch (e) {
            this.loaderService.hideAndShowTryAgain();
        }
    }

    closePopup() {
        this.form.reset();
        this.close.emit();
        turnstile.reset();
    }

  onCaptchaResolved(token: string) {
    this.captchaToken = token;
  }

  readonly CaptchaConfig = CaptchaConfig;
}
